import { Box, Button, H5, Stack } from "@adfenix/alexandria";
import styled from "styled-components";
import NoImage from "static/svg/no-image";
// @todo REMOVE Level
import { Level } from "react-bulma-components";
import { PageInfo } from "./interfaces";
import { useTranslation } from "react-i18next";

const StyledLinkButton = styled(Button)`
  padding: 0;
  white-space: break-spaces;
  text-align: start;
  max-width: 300px;
`;

const PageItem = ({ pageData }: { pageData: PageInfo }) => {
  const { t } = useTranslation();
  return (
    <Box display="flex">
      <Level.Item
        style={{
          padding: 16,
          marginRight: 24,
          marginLeft: 24
        }}
      >
        {!pageData.facebook.facebookPageUrl ? (
          <>
            <NoImage
              style={{
                marginRight: 16
              }}
            />
            <Stack spacing="xs">
              <Box>
                <small>Facebook</small>
              </Box>
              <Box>
                <H5>{t("selfonboarding.pageItem.noConnection.label")}</H5>
              </Box>
            </Stack>
          </>
        ) : (
          <Box display="flex">
            <Box
              display="flex"
              style={{ flexGrow: 1, width: 72, height: 72, marginRight: 16 }}
            >
              <img src={pageData.facebook.facebookProfilePicture} />
            </Box>
            <Box display="flex" style={{ flexGrow: 1 }}>
              <Stack spacing="xs">
                <Box>
                  <small>Facebook</small>
                </Box>
                <Box>
                  <StyledLinkButton
                    logLabel="selfonboarding-facebook-link-button"
                    onClick={() =>
                      window.open(pageData.facebook.facebookPageUrl, "_blank")
                    }
                    variant="text"
                  >
                    {pageData.facebook.facebookPageName}
                  </StyledLinkButton>
                </Box>
              </Stack>
            </Box>
          </Box>
        )}
      </Level.Item>
      {pageData.instagram && (
        <Box display="flex">
          <Level.Item style={{ marginRight: 24 }}>
            <Box display="flex" style={{ flexGrow: 1 }}>
              {!pageData.instagram?.instagramActorId ? (
                <>
                  <NoImage
                    style={{
                      marginRight: 16
                    }}
                  />
                  <Stack spacing="xs">
                    <Box>
                      <small>Instagram</small>
                    </Box>
                    <Box>
                      <H5>{t("selfonboarding.pageItem.noConnection.label")}</H5>
                    </Box>
                  </Stack>
                </>
              ) : (
                <Box display="flex">
                  <Box
                    display="flex"
                    style={{
                      flexGrow: 1,
                      width: 72,
                      height: 72,
                      marginRight: 16
                    }}
                  >
                    <img
                      width={72}
                      src={pageData.instagram.instagramProfilePicture}
                    />
                  </Box>
                  <Box display="flex" style={{ flexGrow: 1 }}>
                    <Stack spacing="xs">
                      <Box>
                        <small>Instagram</small>
                      </Box>
                      <Box>
                        <StyledLinkButton
                          logLabel="selfonboarding-instagram-link-button"
                          onClick={() =>
                            window.open(
                              `https://instagram.com/${pageData.instagram?.instagramAccountName}`,
                              "_blank"
                            )
                          }
                          variant="text"
                        >
                          {pageData.instagram.instagramAccountName}
                        </StyledLinkButton>
                      </Box>
                    </Stack>
                  </Box>
                </Box>
              )}
            </Box>
          </Level.Item>
        </Box>
      )}
    </Box>
  );
};

export default PageItem;
